import { render, staticRenderFns } from "./common-table.vue?vue&type=template&id=3c5ac8d3&scoped=true&"
import script from "./common-table.vue?vue&type=script&lang=js&"
export * from "./common-table.vue?vue&type=script&lang=js&"
import style0 from "./common-table.vue?vue&type=style&index=0&id=3c5ac8d3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5ac8d3",
  null
  
)

export default component.exports